import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, } from '@angular/material/dialog';
import { Application } from 'src/app/core/models/application';
import { ApplicationService } from 'src/app/core/services/application.service';
import { CustomActionComponent } from '../../modals/custom-action/custom-action.component';
import { CustomAction } from 'src/app/core/models/customAction';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-application-advance-view',
  templateUrl: './application-advance-view.component.html',
  styleUrl: './application-advance-view.component.scss'
})
export class ApplicationAdvanceViewComponent {

  activeTab = 1;
  selectedApplication: Application = null;
  currentUser = this.authenticationService.currentUserValue;
  @Output() hideDetails = new EventEmitter();
  @Output() handleAction = new EventEmitter();
  actionButtons : {label: string, action: string}[] = [
    { label: 'Add Custom Action', action: 'addCustomAction' },
    { label: 'Clone Application', action: 'Clone' },
    { label: 'Build Application', action: 'Build' },
    { label: 'Update Application', action: 'Update' },
    { label: 'Delete Application', action: 'Delete' },
  ]
    loggedInUserRole: string = this.authenticationService.getRole() || "";
    isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(
    private applicationService: ApplicationService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.applicationService.SelectedApplication.subscribe((x) => {
      this.selectedApplication = x;
    });
  }

  openDetails() {
  }

  close() {
    this.hideDetails.emit();
  }

  emitAction(action: string) {
    if(action === 'addCustomAction'){
      const dialogRef = this.dialog.open(CustomActionComponent, {
        width: '40vw',
        autoFocus: false,
        disableClose: true,
        data: { 
          depName: this.selectedApplication.depName,
          userId: this.currentUser.username,
          dialogHeader: 'Add Custom Action',
          application: this.selectedApplication,
          customAction: new CustomAction(),
        } 
      });

    }
    else{
      this.handleAction.emit(action);
    }
  }
}
